/**
 * Dashboard greeting header.
 */
import React from "react";
import { Box } from "@mui/material";
import { Icon } from "@iconify/react";
import { useTranslation } from "react-i18next";

import { VText } from "form";
import { useAsterController } from "context";

/**
 * Shows the learner name, avatar, and welcome copy.
 */
const DashboardHeader = () => {
  const { t } = useTranslation("common");

  const [controller] = useAsterController();
  const { user } = controller;

  return (
    <Box className="w-full lg:p-0 lg:pt-12 p-2">
      <Box className="lg:rounded-none rounded-md h-44 bg-no-repeat dashboard-bg-position bg-main1" sx={{ backgroundImage: `url("${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/dashboard-header.svg")` }}>
        <Box className="h-full flex justify-between items-center w-10/12 mx-auto px-4">
          <Box className="flex flex-col justify-center w-full sm:w-7/12 lg:w-5/12 gap-4">
            <VText className="text-white text-2xl sm:text-3xl md:text-4xl filter drop-shadow-lg shadow-black text-shadow flex items-center" color="custom" div>
              {t("Good Morning")}, {user.first_name || user.username}!&nbsp;
              <Icon icon="noto:waving-hand" />
            </VText>
            <VText className="text-lg md:text-xl leading-5" color="white">
              {t("Here's update for your training information, your assigntment and progress are all in one places")}
            </VText>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardHeader;
